import { render, staticRenderFns } from "./Flowtypelist.vue?vue&type=template&id=0032f5bf&"
import script from "./Flowtypelist.vue?vue&type=script&lang=js&"
export * from "./Flowtypelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports